// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2fMU9","requiredAsterisk":"Info_requiredAsterisk__36mca"};